import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

export const Route = createFileRoute("/auth")({
  component: AuthPage,
  head: () => ({
    meta: [
      { title: "Admin-Login — PIXIWEB" },
      { name: "description", content: "Geschützter Admin-Login für PIXIWEB. Nur autorisierte Mitarbeitende erhalten Zugriff auf das interne Verwaltungs-Dashboard." },
      { name: "robots", content: "noindex,nofollow" },
      { property: "og:title", content: "Admin-Login — PIXIWEB" },
      { property: "og:description", content: "Geschützter Admin-Login für PIXIWEB. Nur autorisierte Mitarbeitende erhalten Zugriff auf das interne Verwaltungs-Dashboard." },
      { property: "og:url", content: "https://pixiweb.de/auth" },
    ],
    links: [{ rel: "canonical", href: "https://pixiweb.de/auth" }],
  }),
});

function AuthPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    supabase.auth.getUser().then(({ data }) => {
      if (data.user) navigate({ to: "/admin" });
    });
  }, [navigate]);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const { error } = await supabase.auth.signInWithPassword({ email, password });
      if (error) throw error;
      navigate({ to: "/admin" });
    } catch (err: any) {
      setError(err?.message ?? "Fehler beim Anmelden");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-ice px-4 py-12">
      <div className="w-full max-w-md rounded-2xl border border-mist bg-white p-8 shadow-pixi">
        <h1 className="font-display text-2xl font-bold text-navy">Admin-Login</h1>
        <p className="mt-1 text-sm text-slate">Zugriff auf den internen Bereich.</p>
        <form onSubmit={onSubmit} className="mt-6 space-y-4">
          <div>
            <label className="block text-sm font-medium text-navy">E-Mail</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-1 w-full rounded-lg border border-mist px-3 py-2 text-sm focus:border-electric focus:outline-none"
              autoComplete="email"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-navy">Passwort</label>
            <input
              type="password"
              required
              minLength={8}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-1 w-full rounded-lg border border-mist px-3 py-2 text-sm focus:border-electric focus:outline-none"
              autoComplete="current-password"
            />
          </div>
          {error && <p className="text-sm text-red-600">{error}</p>}
          <button
            type="submit"
            disabled={loading}
            className="w-full rounded-xl bg-navy px-5 py-2.5 text-sm font-semibold text-white transition hover:bg-electric disabled:opacity-60"
          >
            {loading ? "Bitte warten…" : "Anmelden"}
          </button>
        </form>
      </div>
    </div>
  );
}
